import { render, staticRenderFns } from "./faturabasma.vue?vue&type=template&id=3394fc88&scoped=true"
import script from "./faturabasma.vue?vue&type=script&lang=js"
export * from "./faturabasma.vue?vue&type=script&lang=js"
import style0 from "./faturabasma.vue?vue&type=style&index=0&id=3394fc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394fc88",
  null
  
)

export default component.exports